/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { SupportNotice } from './SupportNotice';
import { SUPPORT_NOTICE } from '../../../../constants/support';
/**
 * What the customer did with support, kept in the thread so a reload still shows it. Small, centred
 * and muted: a record, never a bubble, with no action bar.
 */
const meta = {
    title: 'Features/AIChatWidget/SupportNotice',
    component: SupportNotice,
    parameters: { layout: 'padded' },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: 480, padding: 16 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const ChatStarted = {
    args: { kind: SUPPORT_NOTICE.CHAT_STARTED, text: 'You started a chat with InspectPoint Support.' }
};
export const EmailSent = {
    args: {
        kind: SUPPORT_NOTICE.EMAIL_SENT,
        text: "You emailed InspectPoint Support. We'll reply to t***@acmefire.example."
    }
};
export const ChatEnded = {
    args: { kind: SUPPORT_NOTICE.CHAT_ENDED, text: 'Chat with InspectPoint Support ended.' }
};
